export default "/assets/images/outdoor-aqi-video.mp4?9ab0a57766531d4d3d173f972b39fac4";